import { Origens, parserRegisterOrigin } from '@acme/common'
import { InputAdornment, TextField } from '@mui/material'
import Menu from '../MenuV2'

interface IProps {
    origemId: number
    label?: string
}

export function OrigemRegistro({ origemId, label = 'Origem' }: IProps) {
    const origem = parserRegisterOrigin(origemId)

    return (
        <TextField
            label={label}
            fullWidth
            variant="filled"
            disabled
            defaultValue={origemId}
            select
            InputProps={{
                endAdornment: (
                    <InputAdornment position="start">
                        <div
                            className="rounded-full size-4 mr-4 mb-3"
                            style={{
                                background: origem.color,
                            }}
                        />
                    </InputAdornment>
                ),
            }}
            helperText=" "
            sx={{
                mb: 1,
            }}
        >
            {Object.entries(Origens).map(([key, value]) => (
                <Menu.Item key={key} value={Number(key)}>
                    {value}
                </Menu.Item>
            ))}
        </TextField>
    )
}
